<script setup lang="ts">
import { watchEffect } from "vue";
import { useRoute } from "vue-router";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import PresentationViewer from "@/components/PresentationViewer.vue";
const route = useRoute();
watchEffect(() => {
  const title = route.meta.title;
  document.documentElement.lang = "en";
  document.title = title
    ? `${title} — NITRO-DETEX`
    : "NITRO-DETEX — Industrial Explosives & Initiation Systems";
  document
    .querySelector('meta[name="description"]')
    ?.setAttribute(
      "content",
      String(
        route.meta.description ??
          "Explore NITRO-DETEX industrial explosives, initiation systems, bulk emulsion equipment and field services for mining, infrastructure and industry.",
      ),
    );
});
</script>
<template>
  <a class="skip" href="#main-content">Skip to content</a>
  <AppHeader />
  <RouterView />
  <AppFooter />
  <PresentationViewer />
</template>
